import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { isParent, RowExpanderColumn } from 'components/Table'

import type { FinanceReportRow } from './useGetFinanceReport'
import type { ColumnDef } from '@tanstack/react-table'

export const useColumns = (): ColumnDef<FinanceReportRow>[] => {
  const { t } = useTranslation('features/finance', { keyPrefix: 'monthlyEarnings.columns' })

  return [
    RowExpanderColumn<FinanceReportRow>(),
    {
      accessorKey: 'period',
      header: t('period'),
    },
    {
      accessorKey: 'product',
      header: t('product'),
    },
    {
      accessorKey: 'amount',
      cell: ({ row }) => {
        return isParent(row) ? (
          <Typography sx={{ fontWeight: 'bold' }}>{row.original.amount}</Typography>
        ) : (
          row.original.amount
        )
      },
      header: t('amount'),
    },
  ]
}
